import React from "react";

const ErrorMessage = ({ errorType, messages }) => {
  return <p className="text-danger">{errorType && messages[errorType]}</p>;
};

export default ErrorMessage;
